export enum TransactionStatus {
  Requested = 'Requested',
  Completed = 'Completed',
  Cancelled = 'Cancel'
}

export enum TransactionStatusCode {
  Requested = '22',
  Completed = '0',
  Cancelled = '7'
}

export enum TransactionMultiStepWorkflowstatus {
  Approved = 'APPROVED',
  Refused = 'REFUSED'
}
